// // AdminDashboard.js (updated)
// // NOTE: install the icons package if you haven't:
// // npm install @react-icons/all-files

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { API_BASE_URL } from "../config";

// // React Icons (all-files imports as requested)
// import { FaBolt } from "@react-icons/all-files/fa/FaBolt";
// import { FaChartBar } from "@react-icons/all-files/fa/FaChartBar";
// import { FaUserPlus } from "@react-icons/all-files/fa/FaUserPlus";
// import { FaUsers } from "@react-icons/all-files/fa/FaUsers";
// import { FaUserTie } from "@react-icons/all-files/fa/FaUserTie";
// import { FaPencilAlt } from "@react-icons/all-files/fa/FaPencilAlt";
// import { FaHourglassHalf } from "@react-icons/all-files/fa/FaHourglassHalf";
// import { FaSyncAlt } from "@react-icons/all-files/fa/FaSyncAlt";
// import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
// import { FaSignOutAlt } from "@react-icons/all-files/fa/FaSignOutAlt";
// import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";
// import { FaExclamationTriangle } from "@react-icons/all-files/fa/FaExclamationTriangle";

// const styles = {
//   container: {
//     minHeight: "100vh",
//     backgroundColor: "#f8fafc",
//     display: "flex",
//     width: "100%",
//     margin: 0
//   },
//   sidebar: {
//     width: "280px",
//     backgroundColor: "#1e293b",
//     color: "white",
//     padding: "0",
//     boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
//   },
//   logo: {
//     display: 'flex',
//   flexDirection: 'column', // Change from 'row' to 'column'
//   alignItems: 'center',
//   gap: '1px', // Space between logo and text

//   },
//      logoImage: {
//   height: '40px', // Adjust size as needed
//   width: 'auto',
//   marginBottom: '10px',
//   marginTop: '20px',
// },
//   logoIcon: {
//     fontSize: "22px",
//   },
//   logoText: {
//     fontSize: "20px",
//     fontWeight: "700",
//   },
//   nav: {
//     padding: "20px 0",
//   },
//   navItem: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "14px 20px",
//     cursor: "pointer",
//     transition: "all 0.3s",
//     borderLeftWidth: "4px",
//     borderLeftStyle: "solid",
//     borderLeftColor: "transparent",
//     color: "#cbd5e1",
//     textDecoration: "none",
//   },
//   navItemActive: {
//     backgroundColor: "#1d191aff",
//     borderLeftColor: "#3b82f6",
//     color: "white",
//   },
//   navIcon: {
//     width: "20px",
//     textAlign: "center",
//     fontSize: "16px",
//   },
//   mainContent: {
//     flex: 1,
//     display: "flex",
//     flexDirection: "column",
//     overflow: "hidden",
//   },
//   header: {
//     backgroundColor: "white",
//     padding: "20px 30px",
//     borderBottom: "1px solid #e2e8f0",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//   },
//   headerTitle: {
//     fontSize: "24px",
//     fontWeight: "700",
//     color: "#1e293b",
//     margin: 0,
//   },
//   userInfo: {
//     display: "flex",
//     alignItems: "center",
//     gap: "15px",
//   },
//   userName: {
//     fontSize: "14px",
//     fontWeight: "600",
//     color: "#475569",
//   },
//   logoutBtn: {
//     padding: "8px 16px",
//     backgroundColor: "#ef4444",
//     color: "white",
//     border: "none",
//     borderRadius: "6px",
//     cursor: "pointer",
//     fontSize: "13px",
//     fontWeight: "500",
//     transition: "all 0.3s",
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//   },
//   contentArea: {
//     flex: 1,
//     padding: "30px",
//     overflowY: "auto",
//     boxSizing: "border-box",
//   },
//   card: {
//     backgroundColor: "white",
//     borderRadius: "12px",
//     boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
//     border: "1px solid #e2e8f0",
//     boxSizing: "border-box",
//   },
//   statsGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
//     gap: "20px",
//     marginBottom: "30px",
//   },
//   statCard: {
//     padding: "24px",
//     borderRadius: "12px",
//     backgroundColor: "white",
//     border: "1px solid #e2e8f0",
//     transition: "transform 0.2s, box-shadow 0.2s",
//   },
//   statHeader: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginBottom: "12px",
//   },
//   statIcon: {
//     width: "48px",
//     height: "48px",
//     borderRadius: "12px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "20px",
//   },
//   statLabel: {
//     fontSize: "14px",
//     fontWeight: "600",
//     color: "#64748b",
//     marginBottom: "8px",
//   },
//   statValue: {
//     fontSize: "32px",
//     fontWeight: "700",
//     color: "#1e293b",
//   },
//   formCard: {
//     padding: "30px",
//     maxWidth: "700px",
//     boxSizing: "border-box",
//   },
//   formTitle: {
//     fontSize: "24px",
//     fontWeight: "700",
//     color: "#1e293b",
//     marginBottom: "24px",
//     display: "flex",
//     alignItems: "center",
//     gap: "10px",
//   },
//   inputGroup: {
//     marginBottom: "20px",
//   },
//   label: {
//     display: "block",
//     fontSize: "14px",
//     fontWeight: "600",
//     color: "#374151",
//     marginBottom: "8px",
//   },
//   input: {
//     width: "100%",
//     height: "48px",
//     padding: "0 16px",
//     border: "1.5px solid #e2e8f0",
//     borderRadius: "8px",
//     fontSize: "14px",
//     color: "#1e293b",
//     backgroundColor: "white",
//     outline: "none",
//     boxSizing: "border-box",
//     transition: "all 0.3s",
//   },
//   submitBtn: {
//     width: "100%",
//     height: "48px",
//     backgroundColor: "#3b82f6",
//     color: "white",
//     border: "none",
//     borderRadius: "8px",
//     fontSize: "15px",
//     fontWeight: "600",
//     cursor: "pointer",
//     marginTop: "8px",
//     transition: "all 0.3s",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: "8px",
//   },
//   message: {
//     padding: "16px",
//     borderRadius: "8px",
//     marginBottom: "20px",
//     fontSize: "14px",
//     fontWeight: "500",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//   },
//   successMsg: {
//     backgroundColor: "#f0fdf4",
//     color: "#166534",
//     border: "1px solid #bbf7d0",
//   },
//   errorMsg: {
//     backgroundColor: "#fef2f2",
//     color: "#991b1b",
//     border: "1px solid #fecaca",
//   },
//   userManagementHeader: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: "24px",
//   },
//   filterContainer: {
//     display: "flex",
//     gap: "12px",
//     marginBottom: "24px",
//     flexWrap: "wrap",
//     alignItems: "center",
//   },
//   filterBtn: {
//     padding: "8px 16px",
//     border: "1.5px solid #e2e8f0",
//     borderRadius: "8px",
//     backgroundColor: "white",
//     fontSize: "13px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.3s",
//     color: "#64748b",
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//   },
//   filterBtnActive: {
//     backgroundColor: "#3b82f6",
//     color: "white",
//     borderColor: "#3b82f6",
//   },
//   searchInput: {
//     flex: 1,
//     minWidth: "300px",
//     height: "40px",
//     padding: "0 16px",
//     border: "1.5px solid #e2e8f0",
//     borderRadius: "8px",
//     fontSize: "14px",
//     outline: "none",
//     transition: "all 0.3s",
//   },
//   tableContainer: {
//     overflowX: "auto",
//     border: "1px solid #e2e8f0",
//     borderRadius: "12px",
//   },
//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//     fontSize: "14px",
//   },
//   th: {
//     padding: "16px",
//     textAlign: "left",
//     backgroundColor: "#f8fafc",
//     color: "#475569",
//     fontWeight: "600",
//     fontSize: "13px",
//     borderBottom: "1px solid #e2e8f0",
//   },
//   td: {
//     padding: "16px",
//     borderBottom: "1px solid #f1f5f9",
//     color: "#1e293b",
//   },
//   badge: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: "4px",
//     padding: "6px 12px",
//     borderRadius: "20px",
//     fontSize: "12px",
//     fontWeight: "600",
//   },
//   badgeAdmin: {
//     backgroundColor: "#dbeafe",
//     color: "#1e40af",
//   },
//   badgeManual: {
//     backgroundColor: "#f3e8ff",
//     color: "#7c3aed",
//   },
//   badgePending: {
//     backgroundColor: "#fef3c7",
//     color: "#92400e",
//   },
//   badgeCompleted: {
//     backgroundColor: "#d1fae5",
//     color: "#065f46",
//   },
//   noData: {
//     textAlign: "center",
//     padding: "40px",
//     color: "#94a3b8",
//     fontSize: "14px",
//   },
//   refreshBtn: {
//     padding: "10px 20px",
//     backgroundColor: "#3b82f6",
//     color: "white",
//     border: "none",
//     borderRadius: "8px",
//     fontSize: "14px",
//     fontWeight: "600",
//     cursor: "pointer",
//     transition: "all 0.3s",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//   },
// };

// // Dashboard Component - OUTSIDE main component
// const DashboardSection = ({ stats, styles, fetchUsers, setActiveSection }) => (
//   <div>
//     <div style={styles.statsGrid}>
//       <div 
//         style={styles.statCard}
//         onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
//         onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
//       >
//         <div style={styles.statHeader}>
//           <div>
//             <div style={styles.statLabel}>TOTAL USERS</div>
//             <div style={styles.statValue}>{stats.total}</div>
//           </div>
//           <div style={{...styles.statIcon, backgroundColor: "#dbeafe", color: "#1d4ed8"}}>
//             <FaUsers />
//           </div>
//         </div>
//       </div>

//       <div 
//         style={styles.statCard}
//         onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
//         onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
//       >
//         <div style={styles.statHeader}>
//           <div>
//             <div style={styles.statLabel}>ADMIN CREATED</div>
//             <div style={styles.statValue}>{stats.adminCreated}</div>
//           </div>
//           <div style={{...styles.statIcon, backgroundColor: "#dcfce7", color: "#16a34a"}}>
//             <FaUserTie />
//           </div>
//         </div>
//       </div>

//       <div 
//         style={styles.statCard}
//         onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
//         onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
//       >
//         <div style={styles.statHeader}>
//           <div>
//             <div style={styles.statLabel}>SELF REGISTERED</div>
//             <div style={styles.statValue}>{stats.manual}</div>
//           </div>
//           <div style={{...styles.statIcon, backgroundColor: "#fef3c7", color: "#d97706"}}>
//             <FaPencilAlt />
//           </div>
//         </div>
//       </div>

//       <div 
//         style={styles.statCard}
//         onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
//         onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
//       >
//         <div style={styles.statHeader}>
//           <div>
//             <div style={styles.statLabel}>PENDING PAYMENT</div>
//             <div style={styles.statValue}>{stats.pending}</div>
//           </div>
//           <div style={{...styles.statIcon, backgroundColor: "#fee2e2", color: "#dc2626"}}>
//             <FaHourglassHalf />
//           </div>
//         </div>
//       </div>
//     </div>

//     <div style={styles.card}>
//       <div style={{ padding: "24px", borderBottom: "1px solid #e2e8f0" }}>
//         <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1e293b" }}>
//           Quick Actions
//         </h3>
//       </div>
//       <div style={{ padding: "24px", display: "flex", gap: "16px", flexWrap: "wrap" }}>
//         <button
//           style={styles.refreshBtn}
//           onClick={fetchUsers}
//         >
//           <FaSyncAlt /> Refresh Data
//         </button>
//         <button
//           style={{...styles.refreshBtn, backgroundColor: "#10b981"}}
//           onClick={() => setActiveSection("create-user")}
//         >
//           <FaPlusCircle /> Create New User
//         </button>
//         <button
//           style={{...styles.refreshBtn, backgroundColor: "#8b5cf6"}}
//           onClick={() => setActiveSection("users")}
//         >
//           <FaUsers /> Manage Users
//         </button>
//       </div>
//     </div>
//   </div>
// );

// // Create User Form Component - OUTSIDE main component
// const CreateUserSection = ({ formData, handleChange, handleCreateUser, loading, message, styles }) => (
//   <div style={styles.card}>
//     <div style={styles.formCard}>
//       <h2 style={styles.formTitle}>
//         <FaUserPlus /> Create New User
//       </h2>

//       {message.text && (
//         <div
//           style={{
//             ...styles.message,
//             ...(message.type === "success" ? styles.successMsg : styles.errorMsg),
//           }}
//         >
//           {message.type === "success" ? <FaCheckCircle /> : <FaExclamationTriangle />}{" "}
//           {message.text}
//         </div>
//       )}

//       <form onSubmit={handleCreateUser}>
//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Username</label>
//           <input
//             style={styles.input}
//             type="text"
//             name="username"
//             placeholder="Enter username"
//             value={formData.username}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Password</label>
//           <input
//             style={styles.input}
//             type="text"
//             name="password"
//             placeholder="Enter password"
//             value={formData.password}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Email</label>
//           <input
//             style={styles.input}
//             type="email"
//             name="email"
//             placeholder="Enter email"
//             value={formData.email}
//             onChange={handleChange}
//             required
//           />
//         </div>

//         <div style={styles.inputGroup}>
//           <label style={styles.label}>Phone</label>
//           <input
//             style={styles.input}
//             type="tel"
//             name="phone"
//             placeholder="Enter phone number"
//             value={formData.phone}
//             onChange={handleChange}
//           />
//         </div>

//         <button
//           style={styles.submitBtn}
//           type="submit"
//           disabled={loading}
//         >
//           {loading ? "⏳ Creating..." : <><FaCheckCircle /> Create User</>}
//         </button>
//       </form>
//     </div>
//   </div>
// );

// // Users Management Component - OUTSIDE main component
// const UsersSection = ({ users, filteredUsers, loadingUsers, filterType, filterPayment, searchQuery, setFilterType, setFilterPayment, setSearchQuery, fetchUsers, formatDate, styles }) => (
//   <div style={styles.card}>
//     <div style={{ padding: "30px" }}>
//       <div style={styles.userManagementHeader}>
//         <h2 style={styles.formTitle}>
//           <FaUsers /> Manage Users
//         </h2>
//         <button
//           style={styles.refreshBtn}
//           onClick={fetchUsers}
//           disabled={loadingUsers}
//           onMouseOver={(e) => (e.target.style.backgroundColor = "#2563eb")}
//           onMouseOut={(e) => (e.target.style.backgroundColor = "#3b82f6")}
//         >
//           {loadingUsers ? "⏳ Loading..." : <><FaSyncAlt /> Refresh</>}
//         </button>
//       </div>

//       {/* Filters */}
//       <div style={styles.filterContainer}>
//         <button
//           style={{
//             ...styles.filterBtn,
//             ...(filterType === "all" ? styles.filterBtnActive : {}),
//           }}
//           onClick={() => setFilterType("all")}
//         >
//           <FaUsers /> All Users
//         </button>
//         <button
//           style={{
//             ...styles.filterBtn,
//             ...(filterType === "admin" ? styles.filterBtnActive : {}),
//           }}
//           onClick={() => setFilterType("admin")}
//         >
//           <FaUserTie /> Admin Created
//         </button>
//         <button
//           style={{
//             ...styles.filterBtn,
//             ...(filterType === "manual" ? styles.filterBtnActive : {}),
//           }}
//           onClick={() => setFilterType("manual")}
//         >
//           <FaPencilAlt /> Self Registered
//         </button>
        
//         <button
//           style={{
//             ...styles.filterBtn,
//             ...(filterPayment === "pending" ? styles.filterBtnActive : {}),
//           }}
//           onClick={() => setFilterPayment(filterPayment === "pending" ? "all" : "pending")}
//         >
//           <FaHourglassHalf /> Pending Payment
//         </button>
//         <button
//           style={{
//             ...styles.filterBtn,
//             ...(filterPayment === "completed" ? styles.filterBtnActive : {}),
//           }}
//           onClick={() => setFilterPayment(filterPayment === "completed" ? "all" : "completed")}
//         >
//           <FaCheckCircle /> Completed Payment
//         </button>

//         <input
//           style={styles.searchInput}
//           type="text"
//           placeholder="🔍 Search by username, email, or phone..."
//           value={searchQuery}
//           onChange={(e) => setSearchQuery(e.target.value)}
//         />
//       </div>

//       {/* Table */}
//       <div style={styles.tableContainer}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>Username</th>
//               <th style={styles.th}>Email</th>
//               <th style={styles.th}>Phone</th>
//               <th style={styles.th}>Registration Type</th>
//               <th style={styles.th}>Payment Status</th>
//               <th style={styles.th}>Role</th>
//               <th style={styles.th}>Created At</th>
//             </tr>
//           </thead>
//           <tbody>
//             {loadingUsers ? (
//               <tr>
//                 <td colSpan="7" style={styles.noData}>
//                   ⏳ Loading users...
//                 </td>
//               </tr>
//             ) : filteredUsers.length === 0 ? (
//               <tr>
//                 <td colSpan="7" style={styles.noData}>
//                   📭 No users found
//                 </td>
//               </tr>
//             ) : (
//               filteredUsers.map((user) => (
//                 <tr key={user.id}>
//                   <td style={styles.td}>{user.username}</td>
//                   <td style={styles.td}>{user.email}</td>
//                   <td style={styles.td}>{user.phone || "-"}</td>
//                   <td style={styles.td}>
//                     <span
//                       style={{
//                         ...styles.badge,
//                         ...(user.registration_type === "admin"
//                           ? styles.badgeAdmin
//                           : styles.badgeManual),
//                       }}
//                     >
//                       {user.registration_type === "admin" ? <><FaUserTie /> Admin</> : <><FaPencilAlt /> Manual</>}
//                     </span>
//                   </td>
//                   <td style={styles.td}>
//                     <span
//                       style={{
//                         ...styles.badge,
//                         ...(user.payment_status === "completed"
//                           ? styles.badgeCompleted
//                           : styles.badgePending),
//                       }}
//                     >
//                       {user.payment_status === "completed" ? "✓ Paid" : "⏳ Pending"}
//                     </span>
//                   </td>
//                   <td style={styles.td}>{user.role}</td>
//                   <td style={styles.td}>{formatDate(user.created_at)}</td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Results count */}
//       {!loadingUsers && (
//         <div style={{ marginTop: "16px", fontSize: "14px", color: "#64748b", textAlign: "right" }}>
//           Showing {filteredUsers.length} of {users.length} users
//         </div>
//       )}
//     </div>
//   </div>
// );

// // Main AdminDashboard Component
// function AdminDashboard({ onLogout }) {
//   const [activeSection, setActiveSection] = useState("dashboard");
//   const [formData, setFormData] = useState({
//     username: "",
//     password: "",
//     email: "",
//     phone: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });
  
//   // User management states
//   const [users, setUsers] = useState([]);
//   const [filteredUsers, setFilteredUsers] = useState([]);
//   const [loadingUsers, setLoadingUsers] = useState(false);
//   const [filterType, setFilterType] = useState("all");
//   const [filterPayment, setFilterPayment] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");

//   // Fetch users on component mount
//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   // Apply filters whenever they change
//   useEffect(() => {
//     applyFilters();
//   }, [users, filterType, filterPayment, searchQuery]);

//   const fetchUsers = async () => {
//     setLoadingUsers(true);
//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.get(`${API_BASE_URL}/admin/users`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setUsers(res.data);
//     } catch (err) {
//       console.error("Fetch users error:", err);
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   const applyFilters = () => {
//     let filtered = [...users];

//     if (filterType !== "all") {
//       filtered = filtered.filter(user => user.registration_type === filterType);
//     }

//     if (filterPayment !== "all") {
//       filtered = filtered.filter(user => user.payment_status === filterPayment);
//     }

//     if (searchQuery.trim()) {
//       const query = searchQuery.toLowerCase();
//       filtered = filtered.filter(
//         user =>
//           user.username.toLowerCase().includes(query) ||
//           user.email.toLowerCase().includes(query) ||
//           (user.phone && user.phone.includes(query))
//       );
//     }

//     setFilteredUsers(filtered);
//   };

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleCreateUser = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage({ type: "", text: "" });

//     try {
//       const token = localStorage.getItem("token");
//       const res = await axios.post(
//         `${API_BASE_URL}/admin/create-user`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       setMessage({ type: "success", text: res.data.message });
      
//       setFormData({
//         username: "",
//         password: "",
//         email: "",
//         phone: "",
//       });

//       fetchUsers();
//       setTimeout(() => {
//         setActiveSection("users");
//       }, 1500);
//     } catch (err) {
//       console.error("Create user error:", err);
//       setMessage({
//         type: "error",
//         text: err.response?.data?.message || "Failed to create user",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("role");
//     localStorage.removeItem("username");
//     if (onLogout) onLogout();
//   };

//   const formatDate = (dateString) => {
//     return new Date(dateString).toLocaleString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const stats = {
//     total: users.length,
//     adminCreated: users.filter(u => u.registration_type === 'admin').length,
//     manual: users.filter(u => u.registration_type === 'manual').length,
//     pending: users.filter(u => u.payment_status === 'pending').length,
//   };

//   // Render active section with props
//   const renderActiveSection = () => {
//     switch (activeSection) {
//       case "dashboard":
//         return <DashboardSection stats={stats} styles={styles} fetchUsers={fetchUsers} setActiveSection={setActiveSection} />;
//       case "create-user":
//         return <CreateUserSection formData={formData} handleChange={handleChange} handleCreateUser={handleCreateUser} loading={loading} message={message} styles={styles} />;
//       case "users":
//         return <UsersSection users={users} filteredUsers={filteredUsers} loadingUsers={loadingUsers} filterType={filterType} filterPayment={filterPayment} searchQuery={searchQuery} setFilterType={setFilterType} setFilterPayment={setFilterPayment} setSearchQuery={setSearchQuery} fetchUsers={fetchUsers} formatDate={formatDate} styles={styles} />;
//       default:
//         return <DashboardSection stats={stats} styles={styles} fetchUsers={fetchUsers} setActiveSection={setActiveSection} />;
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Sidebar */}
//       <div style={styles.sidebar}>
       
//         <div style={styles.logo}>
//             <img src="/images/logo2.png" alt="File Transfer Logo" style={styles.logoImage} />
//           {/* <div style={styles.logoIcon}><FaBolt /></div> */}
//           <div style={styles.logoText}>Admin Panel</div>
//         </div>
        
//         <nav style={styles.nav}>
//           <div
//             style={{
//               ...styles.navItem,
//               ...(activeSection === "dashboard" ? styles.navItemActive : {}),
//             }}
//             onClick={() => setActiveSection("dashboard")}
//           >
//             <span style={styles.navIcon}><FaChartBar /></span>
//             Dashboard
//           </div>
//           <div
//             style={{
//               ...styles.navItem,
//               ...(activeSection === "create-user" ? styles.navItemActive : {}),
//             }}
//             onClick={() => setActiveSection("create-user")}
//           >
//             <span style={styles.navIcon}><FaUserPlus /></span>
//             Create User
//           </div>
//           <div
//             style={{
//               ...styles.navItem,
//               ...(activeSection === "users" ? styles.navItemActive : {}),
//             }}
//             onClick={() => setActiveSection("users")}
//           >
//             <span style={styles.navIcon}><FaUsers /></span>
//             Manage Users
//           </div>
//         </nav>
//       </div>

//       {/* Main Content */}
//       <div style={styles.mainContent}>
//         {/* Header */}
//         <div style={styles.header}>
//           <h1 style={styles.headerTitle}>
//             {activeSection === "dashboard" && "Dashboard Overview"}
//             {activeSection === "create-user" && "Create New User"}
//             {activeSection === "users" && "User Management"}
//           </h1>
//           <div style={styles.userInfo}>
//             <span style={styles.userName}>
//               Welcome, {localStorage.getItem("username")}
//             </span>
//             <button
//               style={styles.logoutBtn}
//               onClick={handleLogout}
//               onMouseOver={(e) => (e.target.style.backgroundColor = "#dc2626")}
//               onMouseOut={(e) => (e.target.style.backgroundColor = "#ef4444")}
//             >
//               <FaSignOutAlt /> Logout
//             </button>
//           </div>
//         </div>

//         {/* Content Area */}
//         <div style={styles.contentArea}>
//           {renderActiveSection()}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AdminDashboard;









// AdminDashboard.js (Mobile Responsive)
import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

// React Icons
import { FaBolt } from "@react-icons/all-files/fa/FaBolt";
import { FaChartBar } from "@react-icons/all-files/fa/FaChartBar";
import { FaUserPlus } from "@react-icons/all-files/fa/FaUserPlus";
import { FaUsers } from "@react-icons/all-files/fa/FaUsers";
import { FaUserTie } from "@react-icons/all-files/fa/FaUserTie";
import { FaPencilAlt } from "@react-icons/all-files/fa/FaPencilAlt";
import { FaHourglassHalf } from "@react-icons/all-files/fa/FaHourglassHalf";
import { FaSyncAlt } from "@react-icons/all-files/fa/FaSyncAlt";
import { FaPlusCircle } from "@react-icons/all-files/fa/FaPlusCircle";
import { FaSignOutAlt } from "@react-icons/all-files/fa/FaSignOutAlt";
import { FaCheckCircle } from "@react-icons/all-files/fa/FaCheckCircle";
import { FaExclamationTriangle } from "@react-icons/all-files/fa/FaExclamationTriangle";
import { FaBars } from "@react-icons/all-files/fa/FaBars";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#f8fafc",
    display: "flex",
    width: "100%",
    margin: 0,
    position: "relative",
  },
  sidebar: {
    width: "280px",
    backgroundColor: "#1e293b",
    color: "white",
    padding: "0",
    boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
    position: "fixed",
    height: "100vh",
    overflowY: "auto",
    zIndex: 1000,
  },
  sidebarMobile: {
    transform: "translateX(-100%)",
    transition: "transform 0.3s ease",
  },
  sidebarOpen: {
    transform: "translateX(0)",
  },
  overlay: {
    display: "none",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  overlayActive: {
    display: "block",
  },
  logo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1px',
  },
  logoImage: {
    height: '40px',
    width: 'auto',
    marginBottom: '10px',
    marginTop: '20px',
  },
  logoIcon: {
    fontSize: "22px",
  },
  logoText: {
    fontSize: "20px",
    fontWeight: "700",
  },
  nav: {
    padding: "20px 0",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "14px 20px",
    cursor: "pointer",
    transition: "all 0.3s",
    borderLeftWidth: "4px",
    borderLeftStyle: "solid",
    borderLeftColor: "transparent",
    color: "#cbd5e1",
    textDecoration: "none",
  },
  navItemActive: {
    backgroundColor: "#1d191aff",
    borderLeftColor: "#3b82f6",
    color: "white",
  },
  navIcon: {
    width: "20px",
    textAlign: "center",
    fontSize: "16px",
  },
  mainContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    marginLeft: "280px",
    width: "calc(100% - 280px)",
  },
  hamburger: {
    display: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#1e293b",
  },
  header: {
    backgroundColor: "white",
    padding: "20px 30px",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    gap: "15px",
    flexWrap: "wrap",
  },
  headerTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1e293b",
    margin: 0,
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    flexWrap: "wrap",
  },
  userName: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#475569",
  },
  logoutBtn: {
    padding: "8px 16px",
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "500",
    transition: "all 0.3s",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  contentArea: {
    flex: 1,
    padding: "30px",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    border: "1px solid #e2e8f0",
    boxSizing: "border-box",
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "20px",
    marginBottom: "30px",
  },
  statCard: {
    padding: "24px",
    borderRadius: "12px",
    backgroundColor: "white",
    border: "1px solid #e2e8f0",
    transition: "transform 0.2s, box-shadow 0.2s",
  },
  statHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  statIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
  },
  statLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#64748b",
    marginBottom: "8px",
  },
  statValue: {
    fontSize: "32px",
    fontWeight: "700",
    color: "#1e293b",
  },
  formCard: {
    padding: "30px",
    maxWidth: "700px",
    boxSizing: "border-box",
  },
  formTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1e293b",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  inputGroup: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "8px",
  },
  input: {
    width: "100%",
    height: "48px",
    padding: "0 16px",
    border: "1.5px solid #e2e8f0",
    borderRadius: "8px",
    fontSize: "14px",
    color: "#1e293b",
    backgroundColor: "white",
    outline: "none",
    boxSizing: "border-box",
    transition: "all 0.3s",
  },
  submitBtn: {
    width: "100%",
    height: "48px",
    backgroundColor: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "8px",
    transition: "all 0.3s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  message: {
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "20px",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  successMsg: {
    backgroundColor: "#f0fdf4",
    color: "#166534",
    border: "1px solid #bbf7d0",
  },
  errorMsg: {
    backgroundColor: "#fef2f2",
    color: "#991b1b",
    border: "1px solid #fecaca",
  },
  userManagementHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    flexWrap: "wrap",
    gap: "15px",
  },
  filterContainer: {
    display: "flex",
    gap: "12px",
    marginBottom: "24px",
    flexWrap: "wrap",
    alignItems: "center",
  },
  filterBtn: {
    padding: "8px 16px",
    border: "1.5px solid #e2e8f0",
    borderRadius: "8px",
    backgroundColor: "white",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s",
    color: "#64748b",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  filterBtnActive: {
    backgroundColor: "#3b82f6",
    color: "white",
    borderColor: "#3b82f6",
  },
  searchInput: {
    flex: 1,
    minWidth: "250px",
    height: "40px",
    // padding: "0 16px",
    border: "1.5px solid #e2e8f0",
    borderRadius: "8px",
    fontSize: "14px",
    outline: "none",
    transition: "all 0.3s",
  },
  tableContainer: {
    overflowX: "auto",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "14px",
    minWidth: "800px",
  },
  th: {
    padding: "16px",
    textAlign: "left",
    backgroundColor: "#f8fafc",
    color: "#475569",
    fontWeight: "600",
    fontSize: "13px",
    borderBottom: "1px solid #e2e8f0",
  },
  td: {
    padding: "16px",
    borderBottom: "1px solid #f1f5f9",
    color: "#1e293b",
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
  },
  badgeAdmin: {
    backgroundColor: "#dbeafe",
    color: "#1e40af",
  },
  badgeManual: {
    backgroundColor: "#f3e8ff",
    color: "#7c3aed",
  },
  badgePending: {
    backgroundColor: "#fef3c7",
    color: "#92400e",
  },
  badgeCompleted: {
    backgroundColor: "#d1fae5",
    color: "#065f46",
  },
  noData: {
    textAlign: "center",
    padding: "40px",
    color: "#94a3b8",
    fontSize: "14px",
  },
  refreshBtn: {
    padding: "10px 20px",
    backgroundColor: "#3b82f6",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
};

// Dashboard Component
const DashboardSection = ({ stats, styles, fetchUsers, setActiveSection }) => (
  <div>
    <div style={styles.statsGrid}>
      <div 
        style={styles.statCard}
        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
      >
        <div style={styles.statHeader}>
          <div>
            <div style={styles.statLabel}>TOTAL USERS</div>
            <div style={styles.statValue}>{stats.total}</div>
          </div>
          <div style={{...styles.statIcon, backgroundColor: "#dbeafe", color: "#1d4ed8"}}>
            <FaUsers />
          </div>
        </div>
      </div>

      <div 
        style={styles.statCard}
        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
      >
        <div style={styles.statHeader}>
          <div>
            <div style={styles.statLabel}>ADMIN CREATED</div>
            <div style={styles.statValue}>{stats.adminCreated}</div>
          </div>
          <div style={{...styles.statIcon, backgroundColor: "#dcfce7", color: "#16a34a"}}>
            <FaUserTie />
          </div>
        </div>
      </div>

      <div 
        style={styles.statCard}
        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
      >
        <div style={styles.statHeader}>
          <div>
            <div style={styles.statLabel}>SELF REGISTERED</div>
            <div style={styles.statValue}>{stats.manual}</div>
          </div>
          <div style={{...styles.statIcon, backgroundColor: "#fef3c7", color: "#d97706"}}>
            <FaPencilAlt />
          </div>
        </div>
      </div>

      <div 
        style={styles.statCard}
        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
      >
        <div style={styles.statHeader}>
          <div>
            <div style={styles.statLabel}>PENDING PAYMENT</div>
            <div style={styles.statValue}>{stats.pending}</div>
          </div>
          <div style={{...styles.statIcon, backgroundColor: "#fee2e2", color: "#dc2626"}}>
            <FaHourglassHalf />
          </div>
        </div>
      </div>
    </div>

    <div style={styles.card}>
      <div style={{ padding: "24px", borderBottom: "1px solid #e2e8f0" }}>
        <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "#1e293b" }}>
          Quick Actions
        </h3>
      </div>
      <div style={{ padding: "24px", display: "flex", gap: "16px", flexWrap: "wrap" }}>
        <button
          style={styles.refreshBtn}
          onClick={fetchUsers}
        >
          <FaSyncAlt /> Refresh Data
        </button>
        <button
          style={{...styles.refreshBtn, backgroundColor: "#10b981"}}
          onClick={() => setActiveSection("create-user")}
        >
          <FaPlusCircle /> Create New User
        </button>
        <button
          style={{...styles.refreshBtn, backgroundColor: "#8b5cf6"}}
          onClick={() => setActiveSection("users")}
        >
          <FaUsers /> Manage Users
        </button>
      </div>
    </div>
  </div>
);

// Create User Form Component
const CreateUserSection = ({ formData, handleChange, handleCreateUser, loading, message, styles }) => (
  <div style={styles.card}>
    <div style={styles.formCard}>
      <h2 style={styles.formTitle}>
        <FaUserPlus /> Create New User
      </h2>

      {message.text && (
        <div
          style={{
            ...styles.message,
            ...(message.type === "success" ? styles.successMsg : styles.errorMsg),
          }}
        >
          {message.type === "success" ? <FaCheckCircle /> : <FaExclamationTriangle />}{" "}
          {message.text}
        </div>
      )}

      <form onSubmit={handleCreateUser}>
        <div style={styles.inputGroup}>
          <label style={styles.label}>Username</label>
          <input
            style={styles.input}
            type="text"
            name="username"
            placeholder="Enter username"
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Password</label>
          <input
            style={styles.input}
            type="text"
            name="password"
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Email</label>
          <input
            style={styles.input}
            type="email"
            name="email"
            placeholder="Enter email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Phone</label>
          <input
            style={styles.input}
            type="tel"
            name="phone"
            placeholder="Enter phone number"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        <button
          style={styles.submitBtn}
          type="submit"
          disabled={loading}
        >
          {loading ? "⏳ Creating..." : <><FaCheckCircle /> Create User</>}
        </button>
      </form>
    </div>
  </div>
);

// Users Management Component
const UsersSection = ({ users, filteredUsers, loadingUsers, filterType, filterPayment, searchQuery, setFilterType, setFilterPayment, setSearchQuery, fetchUsers, formatDate, styles }) => (
  <div style={styles.card}>
    <div style={{ padding: "30px" }}>
      <div style={styles.userManagementHeader}>
        <h2 style={styles.formTitle}>
          <FaUsers /> Manage Users
        </h2>
        <button
          style={styles.refreshBtn}
          onClick={fetchUsers}
          disabled={loadingUsers}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#2563eb")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#3b82f6")}
        >
          {loadingUsers ? "⏳ Loading..." : <><FaSyncAlt /> Refresh</>}
        </button>
      </div>

      <div style={styles.filterContainer}>
        <button
          style={{
            ...styles.filterBtn,
            ...(filterType === "all" ? styles.filterBtnActive : {}),
          }}
          onClick={() => setFilterType("all")}
        >
          <FaUsers /> All Users
        </button>
        <button
          style={{
            ...styles.filterBtn,
            ...(filterType === "admin" ? styles.filterBtnActive : {}),
          }}
          onClick={() => setFilterType("admin")}
        >
          <FaUserTie /> Admin Created
        </button>
        <button
          style={{
            ...styles.filterBtn,
            ...(filterType === "manual" ? styles.filterBtnActive : {}),
          }}
          onClick={() => setFilterType("manual")}
        >
          <FaPencilAlt /> Self Registered
        </button>
        
        <button
          style={{
            ...styles.filterBtn,
            ...(filterPayment === "pending" ? styles.filterBtnActive : {}),
          }}
          onClick={() => setFilterPayment(filterPayment === "pending" ? "all" : "pending")}
        >
          <FaHourglassHalf /> Pending Payment
        </button>
        <button
          style={{
            ...styles.filterBtn,
            ...(filterPayment === "completed" ? styles.filterBtnActive : {}),
          }}
          onClick={() => setFilterPayment(filterPayment === "completed" ? "all" : "completed")}
        >
          <FaCheckCircle /> Completed Payment
        </button>

        <input
          style={styles.searchInput}
          type="text"
          placeholder="🔍 Search by username, email, or phone..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Username</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Phone</th>
              <th style={styles.th}>Registration Type</th>
              <th style={styles.th}>Payment Status</th>
              <th style={styles.th}>Role</th>
              <th style={styles.th}>Created At</th>
            </tr>
          </thead>
          <tbody>
            {loadingUsers ? (
              <tr>
                <td colSpan="7" style={styles.noData}>
                  ⏳ Loading users...
                </td>
              </tr>
            ) : filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="7" style={styles.noData}>
                  🔭 No users found
                </td>
              </tr>
            ) : (
              filteredUsers.map((user) => (
                <tr key={user.id}>
                  <td style={styles.td}>{user.username}</td>
                  <td style={styles.td}>{user.email}</td>
                  <td style={styles.td}>{user.phone || "-"}</td>
                  <td style={styles.td}>
                    <span
                      style={{
                        ...styles.badge,
                        ...(user.registration_type === "admin"
                          ? styles.badgeAdmin
                          : styles.badgeManual),
                      }}
                    >
                      {user.registration_type === "admin" ? <><FaUserTie /> Admin</> : <><FaPencilAlt /> Manual</>}
                    </span>
                  </td>
                  <td style={styles.td}>
                    <span
                      style={{
                        ...styles.badge,
                        ...(user.payment_status === "completed"
                          ? styles.badgeCompleted
                          : styles.badgePending),
                      }}
                    >
                      {user.payment_status === "completed" ? "✓ Paid" : "⏳ Pending"}
                    </span>
                  </td>
                  <td style={styles.td}>{user.role}</td>
                  <td style={styles.td}>{formatDate(user.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {!loadingUsers && (
        <div style={{ marginTop: "16px", fontSize: "14px", color: "#64748b", textAlign: "right" }}>
          Showing {filteredUsers.length} of {users.length} users
        </div>
      )}
    </div>
  </div>
);

// Main AdminDashboard Component
function AdminDashboard({ onLogout }) {
  const [activeSection, setActiveSection] = useState("dashboard");
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    email: "",
    phone: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [filterType, setFilterType] = useState("all");
  const [filterPayment, setFilterPayment] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [users, filterType, filterPayment, searchQuery]);

  const fetchUsers = async () => {
    setLoadingUsers(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE_URL}/admin/users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(res.data);
    } catch (err) {
      console.error("Fetch users error:", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...users];

    if (filterType !== "all") {
      filtered = filtered.filter(user => user.registration_type === filterType);
    }

    if (filterPayment !== "all") {
      filtered = filtered.filter(user => user.payment_status === filterPayment);
    }

    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(
        user =>
          user.username.toLowerCase().includes(query) ||
          user.email.toLowerCase().includes(query) ||
          (user.phone && user.phone.includes(query))
      );
    }

    setFilteredUsers(filtered);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: "", text: "" });

    try {
      const token = localStorage.getItem("token");
      const res = await axios.post(
        `${API_BASE_URL}/admin/create-user`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage({ type: "success", text: res.data.message });
      
      setFormData({
        username: "",
        password: "",
        email: "",
        phone: "",
      });

      fetchUsers();
      setTimeout(() => {
        setActiveSection("users");
      }, 1500);
    } catch (err) {
      console.error("Create user error:", err);
      setMessage({
        type: "error",
        text: err.response?.data?.message || "Failed to create user",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
    if (onLogout) onLogout();
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const stats = {
    total: users.length,
    adminCreated: users.filter(u => u.registration_type === 'admin').length,
    manual: users.filter(u => u.registration_type === 'manual').length,
    pending: users.filter(u => u.payment_status === 'pending').length,
  };

  const renderActiveSection = () => {
    switch (activeSection) {
      case "dashboard":
        return <DashboardSection stats={stats} styles={styles} fetchUsers={fetchUsers} setActiveSection={setActiveSection} />;
      case "create-user":
        return <CreateUserSection formData={formData} handleChange={handleChange} handleCreateUser={handleCreateUser} loading={loading} message={message} styles={styles} />;
      case "users":
        return <UsersSection users={users} filteredUsers={filteredUsers} loadingUsers={loadingUsers} filterType={filterType} filterPayment={filterPayment} searchQuery={searchQuery} setFilterType={setFilterType} setFilterPayment={setFilterPayment} setSearchQuery={setSearchQuery} fetchUsers={fetchUsers} formatDate={formatDate} styles={styles} />;
      default:
        return <DashboardSection stats={stats} styles={styles} fetchUsers={fetchUsers} setActiveSection={setActiveSection} />;
    }
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @media (max-width: 1024px) {
            .admin-sidebar {
              position: fixed !important;
              transform: translateX(-100%) !important;
              transition: transform 0.3s ease !important;
              z-index: 1000 !important;
            }
            
            .admin-sidebar.open {
              transform: translateX(0) !important;
            }
            
            .admin-main-content {
              margin-left: 0 !important;
              width: 100% !important;
            }
            
            .hamburger-menu {
              display: flex !important;
            }
          }
          
          @media (max-width: 768px) {
            .admin-content-area {
              padding: 20px !important;
            }
            
            .admin-header {
              padding: 15px 20px !important;
            }
            
            .admin-header-title {
              font-size: 20px !important;
            }
            
            .stats-grid {
              grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)) !important;
            }
            
            .stat-card {
              padding: 20px !important;
            }
            
            .stat-value {
              font-size: 28px !important;
            }
            
            .form-card {
              padding: 24px !important;
            }
            
            .form-title {
              font-size: 20px !important;
            }
            
            .filter-container {
              gap: 8px !important;
            }
            
            .search-input {
              min-width: 100% !important;
            }
          }
          
          @media (max-width: 480px) {
            .admin-content-area {
              padding: 15px !important;
            }
            
            .admin-header {
              padding: 12px 15px !important;
            }
            
            .admin-header-title {
              font-size: 18px !important;
            }
            
            .user-name {
              display: none !important;
            }
            
            .stats-grid {
              grid-template-columns: 1fr !important;
              gap: 15px !important;
            }
            
            .stat-card {
              padding: 18px !important;
            }
            
            .stat-value {
              font-size: 24px !important;
            }
            
            .stat-icon {
              width: 40px !important;
              height: 40px !important;
              font-size: 18px !important;
            }
            
            .form-card {
              padding: 20px !important;
            }
            
            .form-title {
              font-size: 18px !important;
              flex-wrap: wrap !important;
            }
            
            .filter-btn {
              font-size: 12px !important;
              padding: 6px 12px !important;
            }
            
            .refresh-btn {
              font-size: 13px !important;
              padding: 8px 16px !important;
            }
            
            .table-container {
              font-size: 12px !important;
            }
            
            .user-management-header {
              flex-direction: column !important;
              align-items: flex-start !important;
            }
          }
        `}
      </style>

      {/* Overlay for mobile */}
      <div 
        className={`overlay ${sidebarOpen ? 'overlay-active' : ''}`}
        style={{
          ...styles.overlay,
          ...(sidebarOpen ? styles.overlayActive : {})
        }}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <div 
        className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}
        style={styles.sidebar}
      >
        <div style={styles.logo}>
          <img src="/images/logo2.png" alt="File Transfer Logo" style={styles.logoImage} />
          <div style={styles.logoText}>Admin Panel</div>
        </div>
        
        <nav style={styles.nav}>
          <div
            style={{
              ...styles.navItem,
              ...(activeSection === "dashboard" ? styles.navItemActive : {}),
            }}
            onClick={() => {
              setActiveSection("dashboard");
              setSidebarOpen(false);
            }}
          >
            <span style={styles.navIcon}><FaChartBar /></span>
            Dashboard
          </div>
          <div
            style={{
              ...styles.navItem,
              ...(activeSection === "create-user" ? styles.navItemActive : {}),
            }}
            onClick={() => {
              setActiveSection("create-user");
              setSidebarOpen(false);
            }}
          >
            <span style={styles.navIcon}><FaUserPlus /></span>
            Create User
          </div>
          <div
            style={{
              ...styles.navItem,
              ...(activeSection === "users" ? styles.navItemActive : {}),
            }}
            onClick={() => {
              setActiveSection("users");
              setSidebarOpen(false);
            }}
          >
            <span style={styles.navIcon}><FaUsers /></span>
            Manage Users
          </div>
        </nav>
      </div>

      {/* Main Content */}
      <div className="admin-main-content" style={styles.mainContent}>
        {/* Header */}
        <div className="admin-header" style={styles.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <div 
              className="hamburger-menu"
              style={styles.hamburger}
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {sidebarOpen ? <FaTimes /> : <FaBars />}
            </div>
            <h1 className="admin-header-title" style={styles.headerTitle}>
              {activeSection === "dashboard" && "Dashboard Overview"}
              {activeSection === "create-user" && "Create New User"}
              {activeSection === "users" && "User Management"}
            </h1>
          </div>
          <div style={styles.userInfo}>
            <span className="user-name" style={styles.userName}>
              Welcome, {localStorage.getItem("username")}
            </span>
            <button
              style={styles.logoutBtn}
              onClick={handleLogout}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#dc2626")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#ef4444")}
            >
              <FaSignOutAlt /> Logout
            </button>
          </div>
        </div>

        {/* Content Area */}
        <div className="admin-content-area" style={styles.contentArea}>
          <div className="stats-grid" style={activeSection === "dashboard" ? {} : { display: "none" }}>
            {renderActiveSection()}
          </div>
          {activeSection !== "dashboard" && renderActiveSection()}
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
